// extracted by mini-css-extract-plugin
export var defaultWrapper = "_lk-3";
export var downloadButton = "_lk-4";
export var fileContainer = "_lk-9 _lk-7";
export var fileContainerBase = "_lk-7";
export var fileContainerFixedHeight = "_lk-8 _lk-7";
export var fileInfo = "_lk-5";
export var fileInfoWidthRestricted = "_lk-6";
export var fileType = "_lk-1";
export var fileTypeName = "_lk-2";
export var image = "_lk-0";
export var link = "_lk-b";
export var overflowEllipsis = "_lk-a";